import { useAPI } from "kw/api/useAPI";
import { $ } from "kw/api";
import { useState } from "react";
import { deref } from "kanopi-components/utils";
import { ClaimStateFilterEnum, ClaimFilterBy } from "kw/api/zeus";
import { substituteProfileData } from "kw/util/substituteRiskData";

export const useClaims = () => {
  const [claims, setClaims] = useState<TAdminClaims>();
  const [claim, setClaim] = useState<TClaim>();
  const [notes, setNotes] = useState<[TNote]>();
  const { query, loading } = useAPI();
  const fetchClaims = (search = "", filterBy = ClaimFilterBy.ALL, page: number) => {
    query(
      claimsQuery,
      (response: { admin: { claims: TAdminClaims } }) => {
        setClaims(response.admin.claims);
      },
      {
        search,
        filterBy,
        page,
      }
    );
  };

  const searchClaims = (search = "", filterBy = ClaimFilterBy.ALL, page = 1) => {
    query(
      claimsQuery,
      (response: { admin: { claims: TAdminClaims } }) => {
        setClaims(response.admin.claims);
      },
      {
        search: search,
        page: page,
        filterBy: filterBy,
      }
    );
  };

  const fetchClaim = (id: string, filterBy = ClaimStateFilterEnum.SUMMARY) => {
    query(
      claimQuery,
      (response: { admin: { claim: { details: TClaim } } }) => {
        let _claim = response.admin.claim.details;
        const results = [];
        let finalClaimProfile;
        for (const questionSet of _claim.claimProfile?.claimStateQuestionSets || []) {
          const [enquiry, claimProfile] = substituteProfileData(
            {
              questionSet,
            },
            deref(response.admin, "claim.details.claimProfile", {})
          );
          results.push(enquiry.questionSet);
          finalClaimProfile = claimProfile;
          finalClaimProfile = {
            ...finalClaimProfile,
            riskStateQuestionSets: results,
            riskData: finalClaimProfile.data,
          };
        }
        _claim = {
          ...response.admin.claim.details,
          ...{ claimProfile: finalClaimProfile },
        };
        setClaim(_claim);
        setNotes(response.admin.claim.notes);
      },
      {
        id,
        filterBy,
      }
    );
  };
  return {
    claims,
    claim,
    notes,
    loading,
    fetchClaims,
    fetchClaim,
    searchClaims,
  };
};

const claimsQuery = {
  admin: {
    claims: [
      {
        search: $("search", "String!"),
        filterBy: $("filterBy", "ClaimFilterBy!"),
        page: $("page", "Int!"),
      },
      {
        totalItemCount: true,
        page: true,
        pageCount: true,
        pageSize: true,
        hasNext: true,
        hasPrev: true,
        items: {
          id: true,
          claimProfile: {
            owner: {
              firstName: true,
              lastName: true,
            },
          },
          created: true,
          statusType: true,
          statusTypeDisplay: true,
        },
      },
    ],
  },
};

const claimQuery = {
  admin: {
    claim: [
      {
        id: $("id", "ID!"),
      },
      {
        details: {
          id: true,
          created: true,
          policyNumber: true,
          policyPeriods: {
            policy: {
              id: true,
            },
          },
          statusType: true,
          statusTypeDisplay: true,
          decision: true,
          claimProfile: {
            id: true,
            owner: {
              id: true,
              firstName: true,
              lastName: true,
              isActive: true,
              email: true,
            },
            products: {
              name: true,
            },
            data: true,
            claimStateQuestionSets: [
              {
                filterBy: $("filterBy", "ClaimStateFilterEnum!"),
              },
              {
                id: true,
                title: true,
                description: true,
                key: true,
                questions: {
                  id: true,
                  help: true,
                  label: true,
                  inputType: true,
                  inputArgs: true,
                  storagePath: true,
                  order: true,
                  validators: true,
                  default: true,
                },
                order: true,
              },
            ],
          },
        },
        notes: [
          {},
          {
            id: true,
            content: true,
            author: {
              id: true,
              firstName: true,
              lastName: true,
            },
            created: true,
          },
        ],
      },
    ],
  },
};
